/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Builtin_TriageInputs */

const en_views_builtin_triage = /** @type {(inputs: Views_Builtin_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triage`)
};

const de_views_builtin_triage = /** @type {(inputs: Views_Builtin_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtung`)
};

/**
* | output |
* | --- |
* | "Triage" |
*
* @param {Views_Builtin_TriageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_builtin_triage = /** @type {((inputs?: Views_Builtin_TriageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Builtin_TriageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_builtin_triage(inputs)
	return en_views_builtin_triage(inputs)
});